import { FC } from 'react'
import { ErrorViewer } from 'react-common'
import { useTranslation } from 'react-i18next'
import { useDocTitle } from '@/features/wa/title/useDocTitle'

export const NotFoundPage: FC = () => {
  const { t } = useTranslation()
  useDocTitle('pageError.code404Title')

  return <ErrorViewer code={404} buttonText={t('pageError.redirectTextLearner')} />
}
